module.exports = __webpack_public_path__ + "img/eintracht-frankfurt.69f36c76.png";